import { rest, type RequestHandler } from 'msw'

export const checkPermissionHandlers: RequestHandler[] = [
  rest.post('/permissions/api/v1/permission/check', async (_req, res, ctx) => {
    return res(ctx.json({ permission: 'HAS_PERMISSION' }))
  })
]
